<template>
  <div></div>
  <!--<v-layout row class="align-center layout px-4 pt-4 app&#45;&#45;page-header">-->

    <!--<v-breadcrumbs divider="-">-->
      <!--<v-breadcrumbs-item>-->
      <!--&lt;!&ndash;<v-icon larg>home</v-icon>&ndash;&gt;-->
      <!--</v-breadcrumbs-item>-->
      <!--<v-breadcrumbs-item v-for="(item,key) in breadcrumbs" :key="key">-->
      <!--{{ item }}-->
      <!--</v-breadcrumbs-item>-->
    <!--</v-breadcrumbs>-->
    <!--<v-spacer></v-spacer>-->
    <!--<div class="page-header-right">-->
      <!--<v-btn icon>-->
        <!--<v-icon class="text&#45;&#45;secondary">refresh</v-icon>-->
      <!--</v-btn>-->
    <!--</div>-->
  <!--</v-layout>-->
</template>

<script>
import menu from '~/menu';
export default {
  data () {
    return {
      title: '',
      menus: []
    };
  },
  computed: {
    breadcrumbs: function () {

      let breadcrumbs = [];
      this.menus.forEach(item => {
        if (item.items) {
          let child =  item.items.find(i => {
            return i.name === this.$route.name;
          });
          if (child) {
            // breadcrumbs.push(item.title);
            // breadcrumbs.push(child.title);
            this.title = this.$t(child.title);
          }
        } else {
          if (item.name === this.$route.name) {
            this.title = this.$t(item.title);
            // breadcrumbs.push(item.title);
          }
        }
      });
      return breadcrumbs;
    },
  },
  mounted() {

    this.menus = menu;
  }
};
</script>

<style>
  h3 {
    font-size: 24px;
  }
</style>
